import clsx from "clsx";
import { ReactNode } from "react";

interface LineIndentProps {
  children: ReactNode;
  borderClassName?: string;
  className?: string;
}

const LineIndent = ({ children, className, borderClassName }: LineIndentProps) => {
  return (
    <div className={clsx("grid grid-cols-[auto_1fr] gap-6", className)}>
      <div className={clsx("border-r-2", borderClassName ? borderClassName : "border-gray-10")} />
      <div>{children}</div>
    </div>
  );
};

export default LineIndent;
